import apiCaller from '../../config/common.js';

var DataApi = {
  saveCreditCard: function(params, callback, dontShowAjaxSpinner){
    apiCaller({method: 'post', path: '/account/save_credit_card', params: params, callback: callback, dontShowAjaxSpinner});
  },
  productList: function(params, callback){
    apiCaller({method: 'post', path: '/product_list', params: params, callback: callback});
  },
  subscribeProduct: function(params, callback, dontShowAjaxSpinner){
    apiCaller({method: 'post', path: '/subscribe_product', params: params, callback: callback, dontShowAjaxSpinner});
  },
  parentConnectEmail: (params) => {
    apiCaller({method: 'put', baseUrl : '', path: '/parents/'+ params.id + '/send_parent_app_install_email'});
  },
  studentProductList: function(callback){
    apiCaller({method: 'get', url: '/web_api/student/v2/products_list', callback: callback})
  },
  createParentAndAddChild: function(params, callback){
    const signupPageUrlFromFE = window?.location?.href.includes("/purchase") ? "/purchase" : window.location.pathname;
    document.cookie = `signup_page_url=${signupPageUrlFromFE}; path=/`;
    apiCaller({method: 'post', url:'/create_parent_and_add_child', params:params, callback: callback})
  },
  billingZipCode: (params, callback) => {
    apiCaller({method: 'get', path: '/suggest_postal_code', params , callback});
  },
  getClientSecret: (params, callback, errorCallback) => {
    apiCaller({method: 'get', path: '/get_client_secret', params, callback, errorCallback});
  },
  attachPaymentMethodIdWithCustomer: (params, callback, errorCallback) => {
    return apiCaller({method: 'post', path: '/attach_payment_intent', params, callback, errorCallback});
  }
}

var Config = {
  DataApi: DataApi
}

export default Config;
